import { useEffect, useRef } from 'react';

const MapSection = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.querySelectorAll('.reveal').forEach((el) => {
              el.classList.add('revealed');
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="mapa"
      ref={sectionRef}
      className="relative py-20 md:py-28 bg-gradient-to-b from-background-100 to-background-50"
    >
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="reveal inline-flex items-center gap-2 font-label text-xs md:text-sm text-accent-600 tracking-widest uppercase mb-4">
              <span className="w-6 h-px bg-accent-400" />
              Onde Estamos
              <span className="w-6 h-px bg-accent-400" />
            </span>
            <h2 className="reveal reveal-delay-1 font-display text-3xl md:text-5xl text-foreground-900 leading-tight mb-4">
              Venha nos <span className="text-accent-600">conhecer</span>
            </h2>
            <p className="reveal reveal-delay-2 font-body text-base text-foreground-500">
              Estamos localizados em Fortaleza, prontos para atender você.
            </p>
          </div>

          <div className="reveal grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
            {/* Info cards */}
            <div className="lg:col-span-1 space-y-4">
              <div className="glass-warm rounded-3xl p-6 shadow-sm">
                <div className="flex items-start gap-3 mb-5">
                  <div className="w-10 h-10 rounded-xl bg-accent-50 flex items-center justify-center shrink-0">
                    <i className="ri-map-pin-2-line text-accent-600" />
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-800 mb-1">Endereço</h3>
                    <p className="font-body text-sm text-foreground-500 leading-relaxed">
                      Rua Capitão Vasconcelos, 237<br />
                      Alto da Balança, Fortaleza – CE
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 mb-5">
                  <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center shrink-0">
                    <i className="ri-time-line text-primary-600" />
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-800 mb-1">Horário</h3>
                    <p className="font-body text-sm text-foreground-500 leading-relaxed">
                      Segunda à Sexta<br />
                      06:30 às 16:30
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 mb-5">
                  <div className="w-10 h-10 rounded-xl bg-secondary-50 flex items-center justify-center shrink-0">
                    <i className="ri-whatsapp-line text-secondary-700" />
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-800 mb-1">Contato</h3>
                    <p className="font-body text-sm text-foreground-500 leading-relaxed">
                      (85) 98224-5030
                    </p>
                  </div>
                </div>

                <a
                  href="https://maps.google.com/?q=-3.7646,-38.5544"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 font-label text-sm px-5 py-3 rounded-full bg-accent-500 text-white hover:bg-accent-600 transition-all duration-300"
                >
                  <i className="ri-navigation-line" />
                  <span>Como Chegar</span>
                </a>
              </div>
            </div>

            {/* Map */}
            <div className="lg:col-span-2">
              <div className="rounded-3xl overflow-hidden border border-background-200/60 shadow-sm h-[300px] md:h-[400px]">
                <iframe
                  title="Localização Naturalle Sanduíches"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.3179!2d-38.5544!3d-3.7646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c74c0c9e2e8b4d%3A0x5e6e7f8a9b0c1d2e!2sRua+Capitão+Vasconcelos%2C+237%2C+Fortaleza%2C+CE!5e0!3m2!1spt-BR!2sbr!4v1699999999999!5m2!1spt-BR!2sbr"
                  className="w-full h-full border-0"
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSection;